import { render, staticRenderFns } from "./ManageKanban.vue?vue&type=template&id=c300b326&scoped=true&"
import script from "./ManageKanban.vue?vue&type=script&lang=js&"
export * from "./ManageKanban.vue?vue&type=script&lang=js&"
import style0 from "./ManageKanban.vue?vue&type=style&index=0&id=c300b326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c300b326",
  null
  
)

export default component.exports